import { Component } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { CreateMagicSetRequest, CreateMagicSetResponse, MagicSetType } from "@apiserver-rest/ponder-data-client-base";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { take } from "rxjs";

@Component({
    selector: "admin-magic-add-set",
    imports: [BusySpinComponent, ReactiveFormsModule],
    templateUrl: "./admin-magic-add-set.component.html"
})
export class AdminMagicAddSetComponent {
    public isSaving: boolean = false;
    public savingSuccess: boolean = true;
    public createSetForm!: FormGroup;

    public constructor(private ponderDataClient: PonderDataClient, formBuilder: FormBuilder) {
        this.createSetForm = formBuilder.group({
            name: ["", [Validators.required, Validators.minLength(3)]],
            code: ["", [Validators.required, Validators.minLength(3)]],
            released: ["", [Validators.required]],
            type: [MagicSetType.Box, [Validators.required]],
            parentSet: ["", [Validators.minLength(36), Validators.maxLength(36)]],
            parentBlock: ["", [Validators.minLength(36), Validators.maxLength(36)]],
            universesBeyond: [false]
        });
    }
    
    public onSaveClicked(): void {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;
        this.savingSuccess = true;

        var releaseDate = new Date(this.createSetForm.get("released")!.value);
        releaseDate.setDate(releaseDate.getDate() + 1);     // Increment by 1 day because JS is amazing

        var request = new CreateMagicSetRequest({
            name: this.createSetForm.get("name")!.value,
            code: this.createSetForm.get("code")!.value,
            releaseDate: releaseDate,
            setType: this.createSetForm.get("type")!.value,
            parentSetId: this.createSetForm.get("parentSet")!.value,
            parentBlockId: this.createSetForm.get("parentBlock")!.value,
            universesBeyond: this.createSetForm.get("universesBeyond")!.value
        });

        console.log(`parentblockidlength = ${request.parentBlockId?.length}`);
        if (request.parentBlockId?.length == 0) {
            request.parentBlockId = undefined;
        }

        this.ponderDataClient
            .magicSetNew(request)
            .pipe(take(1))
            .subscribe({
                next: (response: CreateMagicSetResponse) => {
                    if (response.success) {
                        this.createSetForm.patchValue({ name: "", code: "" });
                    } else {
                        this.savingSuccess = false;
                    }
                },
                error: () => {
                    this.savingSuccess = false;
                }
            })
            .add(() => { this.isSaving = false; });
    }
}